import { connect } from 'react-redux';

import { errorBoundary, sendTelemetryErrorEvent } from '~commonInfra/components/ErrorBoundary';
import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { enterPredictiveModelSubspace } from '~src/predictiveModel/actions/EnterPredictiveModelSubspaceAction';
import { IPredictiveModelDetailInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { ContentSpaceInfo, enterContentSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { PredictiveModelSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { AppState } from '../../bootstrap/redux/state/AppState';
import {
  PredictiveModelViewerSpace,
  PredictiveModelViewerSpaceDispatchProps,
  PredictiveModelViewerSpaceOwnProps,
  PredictiveModelViewerSpaceStateProps
} from './PredictiveModelViewerSpace';

//Connected space uses state/dispact props to construct the actual props and connect to predictie model space with Redux infra
const mapStateToProps: MapStateToProps<PredictiveModelViewerSpaceStateProps> = (state: AppState) => ({
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<PredictiveModelViewerSpaceDispatchProps, PredictiveModelViewerSpaceOwnProps> = (dispatch, ownProps) => ({
  enterSpace: (predictiveModelDetailInfo?: IPredictiveModelDetailInfo) => {
    dispatch(enterPredictiveModelSubspace(
      predictiveModelDetailInfo ?? ownProps.predictiveModelDetailInfo,
      ownProps.subspaceName as PredictiveModelSubspaceName
    ));
  },
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.predictiveModelInfo));
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.predictiveModelDetailInfo));
  },
  requestSpaceContents,
  populateContentBreadcrumbs,
  enterContentSpace: (contentSpaceInfo: ContentSpaceInfo) => {
    dispatch(enterContentSpace(contentSpaceInfo));
  }
});

const ConnectedPredictiveModelViewerSpaceInternal: React.ComponentClass<PredictiveModelViewerSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PredictiveModelViewerSpace);

export const ConnectedPredictiveModelViewerSpace = errorBoundary<PredictiveModelViewerSpaceOwnProps>
(sendTelemetryErrorEvent)(ConnectedPredictiveModelViewerSpaceInternal);
